// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"f7cd8e86","703":"6d55216e","787":"88901ea8"}[chunkId] + ".chunk.js";
};